import { styled, IconButton } from '@mui/material';

/**
 * Flips an icon 180 degrees. Useful to indicate menu expansion, or row expansion on a table.
 */
const ExpandIconButton = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    })
}))

export default ExpandIconButton;